import { render, staticRenderFns } from "./copyListValuesModal.vue?vue&type=template&id=087c0572&scoped=true&"
import script from "./copyListValuesModal.vue?vue&type=script&lang=js&"
export * from "./copyListValuesModal.vue?vue&type=script&lang=js&"
import style0 from "./copyListValuesModal.vue?vue&type=style&index=0&id=087c0572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c0572",
  null
  
)

export default component.exports